import { Injectable } from '@angular/core';
import { CommonResponse } from '../../../common/response/response';
import { HttpService } from '../../../services/http.service';
import { privateApiUrl } from '../../../private/private-apiUrl';

@Injectable()
export class HeaderService {
    constructor(private httpService: HttpService) {}

    logoutApi(): Promise<CommonResponse> {
        return this.httpService.postAuth(`${privateApiUrl.LOGOUT}`, {}, true);
    }
}
